/** Parse email/contact from various data shapes */
export const parseContactEmail = (email: string | null): string | null => {
    if (!email) return null

    const emailStr = String(email).trim()
    if (!emailStr) return null

    if (emailStr.startsWith('{')) {
        try {
            const obj = JSON.parse(emailStr) as Record<string, string>
            return obj.email || obj.address || obj.value || null
        } catch (e) {
            console.error('Failed to parse email JSON:', e)
        }
    }

    return emailStr
}
